import { Injectable } from '@angular/core';
import { UserManager, UserManagerSettings } from 'oidc-client';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';

@Injectable()
export class LoginService {

  public oidcManager: UserManager;

  public userInfo;

  private currentUserCliendID: string;

  private adminCliendID: string;

  private getClientIdFromUserIdEndpoint: string;

  private oidcConfig: UserManagerSettings;

  constructor() { }

 /**
   *
   * @param observer An Observer Object
   */
  public getUserInfo(observer: Observer<any>) {

    const sessionToken = window.sessionStorage['oidc.user:' + this.oidcConfig.authority + ':' + this.oidcConfig.client_id];

    if (sessionToken) {
      if (Date.now() < JSON.parse(sessionToken).expires_at * 1000) {
        this.getUserInfoFromSession(observer);
        this.oidcManager.signinSilentCallback();
      } else {
        this.oidcManager.signinSilentCallback().then((user) => {
          this.startSilentRenew(observer);
        })
          .catch((error) => { });
      }
    } else {
      this.oidcManager.signinRedirectCallback()
        .then(this.handleSignInRedirect.bind(this, observer))
        .catch(error => {
          this.redirectToLoginPage();
        });
    }

  }

  public login(): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.getUserInfo(observer);
    });
  }

  public authSuccess() {
    return true;
  }

  public logout() {
    this.oidcManager.signoutRedirect();
  }

  public createOidcManager(oidcConfiguration) {
    this.oidcConfig = oidcConfiguration;
    this.oidcManager = new UserManager(this.oidcConfig);
    this.addOidcManagerEvents();
  }


  /**
   * This is the success callback method for the promises getUser() and signinRedirectCallback()
   * of the "oidc-client". If the User Object is not found then we redirect to the sign-in page.
   * @param user the User Object received by the "oidc-client".
   */
  private handleUserInfo(observer: Observer<any>, user) {
    if (user && !user.expired) {
      this.setUserInfo(user);
      observer.next('');
    } else {
      this.oidcManager.signinRedirect();
    }
  }

  /**
   *
   *  @param user the User Object received by the "oidc-client".
   */
  private handleSignInRedirect(observer: Observer<any>, user) {
    if (user && !user.expired) {
      this.setUserInfo(user);
      observer.next('');
    }
  }

  public getAccessToken() {

    this.oidcManager.getUser()
      .then((user) => {
        this.setUserInfo(user);
      })
      .catch(err => {
        this.redirectToLoginPage();
      });

    return this.userInfo.access_token;
  }

  /**
   * get the user id(sub) from the profile object received from the Identity server
   */
  public getUserId() {
    return this.userInfo.profile.sub;
  }

  set currentUserClientId(value) {
    this.currentUserCliendID = value;
  }

  get currentUserClientId() {
    return this.currentUserCliendID;
  }

  set adminClientId(value) {
    if (!this.adminCliendID) {
      this.adminCliendID = value;
    }
  }

  get adminClientId() {
    return this.adminCliendID;
  }

  private addOidcManagerEvents() {
    this.oidcManager.events.addAccessTokenExpired(this.handleTokenExpiration.bind(this, 'EXPIRED'));
    this.oidcManager.events.addAccessTokenExpiring(this.handleTokenExpiration.bind(this, 'EXPIRING'));
    this.oidcManager.events.addUserSignedOut(this.handleUserSignedOut.bind(this));
  }

  handleTokenExpiration(text) {
    this.startSilentRenew();
  }

  private handleUserSignedOut() {
    this.signInUserAgain();
  }

  private signInUserAgain() {
    this.oidcManager.removeUser()
      .then(() => {
        this.login().subscribe(() => {
          console.log('Signed in again');
        });
      });
  }

  private setUserInfo(user) {
    this.userInfo = user;
  }

  private getUserInfoFromSession(observer) {
    this.oidcManager.getUser()
      .then(this.handleUserInfo.bind(this, observer))
      .catch(err => {
        this.redirectToLoginPage();
      });
  }


  startSilentRenew(observer?) {
    console.log('silent clicked');
    this.oidcManager.signinSilent()
      .then((user) => {
        this.setUserInfo(user);
        if (observer) {
          observer.next();
        }
      })
      .catch(error => { });
  }

  private redirectToLoginPage() {
    this.oidcManager.signinRedirect();
  }


}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/services/login.service.ts